const Footer = () => {
    return (
        // add copyrights. maybe add it as background images rather than as an image and make it repeat? 
        <div className="footer">
            <p>Created with
                🖤 by 
                <a href="https://github.com/chriskimty"> Chris Kim</a></p>
        </div>
    )
}

export default Footer;